// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"96f100cb","453":"0eb3d5ee","455":"3784be1a","977":"1010834b"}[chunkId] + ".chunk.js";
};